import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import Login from "./components/Login";
import DualAuth from "./components/DualAuth";
import usePersonAuthStore from "../../store/personAuthStore"
import DefaultContainer from "../../../components/DefaultContainer";

const LoginPage = () => {
  const [dualAuth, setDualAuth] = useState<boolean>(false);
  const [tempId, setTempId] = useState<string | null>(null)
  const navigate = useNavigate()
  const onSuccess = (data: string) => {
    setDualAuth(true)
    setTempId(data)
  }
  const accessToken = usePersonAuthStore(state => state.access_token);
  useEffect(() => {
    if (!accessToken) return;
    navigate("/dashboard", { replace: true })
  }, [])

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <DefaultContainer style={{ backgroundSize: "cover", backgroundPosition: "center", }}>
        {dualAuth ?
          <DualAuth tempId={tempId} /> :
          <Login onSuccess={onSuccess} />}
      </DefaultContainer>
    </div>
  )
}

export default LoginPage